import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { faShareNodes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from 'i18next';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

export function MitarbeiterAvatar({
  vorname,
  nachname,
  extern,
  bildUrl,
  className,
}: {
  vorname: string;
  nachname: string;
  bildUrl: string;
  extern: boolean;
  className?: string;
}) {
  return (
    <Avatar>
      {extern && (
        <AvatarFallback className={cn('text-primary-red-500', className)}>
          <TooltipProvider delayDuration={0}>
            <Tooltip>
              <TooltipTrigger>
                <FontAwesomeIcon icon={faShareNodes} size="lg" />
              </TooltipTrigger>
              <TooltipContent side="top">
                {t('domain.arbeitszeiten.create.mitarbeiterSelectExternLabel')}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </AvatarFallback>
      )}
      {!extern && (
        <>
          <AvatarImage src={bildUrl} alt={`${vorname} ${nachname}`} />
          <AvatarFallback className="bg-neutrals-800 text-white">
            {vorname[0] + nachname[0]}
          </AvatarFallback>
        </>
      )}
    </Avatar>
  );
}
